//Hook refresh historic sms

import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { auth, firestore } from '../config/firebase';

export const useSms = () => {
    
    const [sms, setSms] = useState([]);
    const [loadingSms, setLoadingSms] = useState(true);
    const [error, setError] = useState(null);
    const [refresh, setRefresh] = useState(false);
    
    const refreshSms = () => {
        setRefresh(true);
    }

    useEffect(() => {
        const unsubscribe = onSnapshot(query(collection(firestore, "users", auth.currentUser.uid, "sms"), orderBy("date", "desc")), (querySnapshot) => {
            const sms = [];
            querySnapshot.forEach((doc) => {
                sms.push({ ...doc.data(), id: doc.id });
            });
            setSms(sms);
            setLoadingSms(false);
            setRefresh(false);
        });
        return unsubscribe;
    }, [refresh]);


    return { sms, loadingSms, error, refreshSms };
}